module.exports = __webpack_public_path__ + "289c8733b802db454dae30d5be4b6b1a.pdf";